<template>
  <div
    class="modal modal-bottom fade"
    id="bottom_modal_terms"
    tabindex="-1"
    role="dialog"
    aria-labelledby="bottom_modal"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content mbr-terms">
        <span class="mbr-terms__handle" aria-hidden="true"></span>
        <button
          type="button"
          class="btn-close mbr-terms__close"
          data-bs-dismiss="modal"
          :aria-label="$t('common.close')"
        >
          <i class="material-icons-round" aria-hidden="true">close</i>
        </button>
        <div class="modal-body mbr-terms__body">
          <img src="../assets/img/terms.jpg" class="mbr-terms__art" alt="" />
          <h2 class="mbr-terms__title">{{ $t('terms.welcome', { brand: merchantBrandName }) }}</h2>
          <p class="mbr-terms__sub">{{ $t('terms.agree_first') }}</p>
          <div class="mbr-terms__agree">
            <material-checkbox @input="changeCheckboxAgree" :checked="iAgree ? true : false" name="iAgree" id="iAgree"
              class="mbr-terms__check">
            </material-checkbox>
            <i18n-t keypath="terms.read_the" tag="span" scope="global">
              <template #terms>
                <button type="button" class="mbr-terms__link" @click="termServiceDetail()">{{ $t('terms.terms_of_service') }}</button>
              </template>
              <template #privacy>
                <button type="button" class="mbr-terms__link" @click="privacyPolicyDetail()">{{ $t('terms.privacy_policy') }}</button>
              </template>
            </i18n-t>
          </div>
          <material-button size="lg" full-width class="mbr-terms__cta" @click="agree">
            {{ $t('terms.i_agree') }}
          </material-button>
        </div>
      </div>
      <button
        class="bottom_modal_terms"
        style="display: none"
        data-bs-toggle="modal"
        data-bs-target="#bottom_modal_terms"
      >
        Show Model
      </button>
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import $ from "jquery";
import { localStorageName, getMerchantCode } from "@/config/utils";

export default {
  name: "TermService",
  components: {
    MaterialButton,
    MaterialCheckbox,
  },
  props: {
    iAgree: {
      type: Boolean,
    },
    phone: {
      type: String,
    },
    changeCheckboxAgree: {
      type: Function,
      default: () => { },
    },
    agree: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      merchantCode: "",
      merchantBrandName: "",
      branchCode: "",
      tableCode: "",
      from: "",
    };
  },
  mounted() {
    const code = getMerchantCode();
    this.merchantCode = code ? `/${code}` : "";
    const brandName = localStorage.getItem(localStorageName("MERCHANT_BRAND_NAME"), "");
    this.merchantBrandName = code ? brandName : "";
    this.branchCode = this.$route.query.branch_code ?? '';
    this.tableCode = this.$route.query.table_code ?? '';
    this.from = this.$route.query.from ?? '';
  },
  methods: {
    termServiceDetail() {
      $(".btn-close").click();
      this.$router.push({ path: this.merchantCode + "/terms-service", query: { phone: this.phone, branch_code: this.branchCode, table_code: this.tableCode, from: this.from } });
    },
    privacyPolicyDetail() {
      $(".btn-close").click();
      this.$router.push({ path: this.merchantCode + "/privacy-policy", query: { phone: this.phone, branch_code: this.branchCode, table_code: this.tableCode, from: this.from } });
    },
  },
};
</script>
<style scoped>
/* Bottom sheet mechanics (the only modal variant this component uses) */
.modal.modal-bottom {
  z-index: 10000;
}

.modal.modal-bottom .modal-dialog {
  position: fixed;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: auto;
  transform: translate3d(0%, 0, 0);
}

.modal.modal-bottom .modal-content {
  height: auto;
  overflow-y: auto;
  border: none;
  border-radius: 0;
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}

/* MBR006 Heritage Hearth bottom sheet. Selectors stack .modal.modal-bottom to
   outrank the generic modal rules above. */
.modal.modal-bottom .modal-content.mbr-terms {
  position: relative;
  max-width: 440px;
  max-height: 92vh;
  margin: 0 auto;
  overflow-y: auto;
  background: var(--mbr-color-surface);
  border-radius: 32px 32px 0 0;
  box-shadow: var(--mbr-shadow-modal);
  font-family: var(--mbr-font-body);
}

.mbr-terms__handle {
  display: block;
  width: 40px;
  height: 4px;
  margin: 12px auto 0;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-outline);
}

/* Keeps .btn-close: SignIn closes this sheet with $(".btn-close").click() */
.btn-close.mbr-terms__close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  background: var(--mbr-color-tint) !important;
  border: 0;
  border-radius: var(--mbr-radius-full);
  box-shadow: none;
  opacity: 1;
  color: var(--mbr-color-ink-headline) !important;
}

.mbr-terms__close .material-icons-round {
  font-size: 22px;
}

.modal.modal-bottom .modal-body.mbr-terms__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 24px calc(32px + env(safe-area-inset-bottom));
  text-align: center;
}

.mbr-terms__art {
  width: 100%;
  max-height: 180px;
  margin-top: 28px;
  object-fit: cover;
  border-radius: 20px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-terms__title {
  margin: 4px 0 0;
  font-family: var(--mbr-font-headline);
  font-size: var(--mbr-headline-md-size);
  font-weight: 700;
  line-height: var(--mbr-headline-md-line);
  letter-spacing: -0.015em;
  color: var(--mbr-color-ink-headline);
}

.mbr-terms__sub {
  margin: -8px 0 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--mbr-color-ink-muted);
}

.mbr-terms__agree {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: var(--mbr-color-tint);
  border: 1px solid color-mix(in srgb, var(--mbr-color-outline) 60%, transparent);
  border-radius: var(--mbr-radius-lg);
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-terms__check {
  flex: none;
  min-height: 0;
  margin: 0;
}

.mbr-terms__link {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-weight: 700;
  color: var(--mbr-color-label);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.mbr-terms__cta {
  margin-top: 4px;
}
</style>
